(function () {
  'use strict';

  // Reveals the prohibited shipping-country notice on an empty cart when the
  // buyer was bounced back from checkout (e.g. their items can't ship to the
  // selected country, so checkout removed them and emptied the cart).
  //
  // Primary signal: a "checkout intent" flag written to sessionStorage on our
  // own origin the moment the buyer left for checkout (see
  // assets/cart-checkout-intent.js). This survives the round-trip through
  // checkout AND any Cloudflare interstitial that sits in between — which the
  // previous document.referrer check did not, because the challenge page
  // replaces the referrer, leaving the cart unable to tell the buyer came from
  // checkout.
  //
  // Secondary signal: document.referrer, kept as a fallback for paths where the
  // intent flag wasn't captured (e.g. an accelerated checkout button inside a
  // cross-origin iframe) and the referrer is still intact.

  var INTENT_KEY = 'pcn_checkout_intent';
  var INTENT_TTL = 30 * 60 * 1000; // 30 min — bounds how long a stale flag can linger

  var banner = document.querySelector('[data-prohibited-notice]');
  if (!banner) return; // only a genuinely empty cart renders the banner

  function reveal() {
    banner.hidden = false;
  }

  function hide() {
    banner.hidden = true;
  }

  function clearIntent() {
    try {
      sessionStorage.removeItem(INTENT_KEY);
    } catch (e) {}
  }

  function hasCheckoutIntent() {
    try {
      var raw = sessionStorage.getItem(INTENT_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!ts || Date.now() - ts > INTENT_TTL) {
        clearIntent();
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function cameFromCheckout() {
    var ref = (document.referrer || '').toLowerCase();
    if (!ref) return false;
    return (
      ref.indexOf('/checkouts/') !== -1 ||
      ref.indexOf('/checkout/') !== -1 ||
      ref.indexOf('checkout.shopify.com') !== -1
    );
  }

  if (hasCheckoutIntent() || cameFromCheckout()) {
    reveal();
  }

  // A back/forward (bfcache) restore can resurrect a previously revealed banner
  // on a page that's no longer relevant — hide it and drop the flag.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      hide();
      clearIntent();
    }
  });

  // The notice only makes sense on a genuinely empty cart. If the live cart
  // actually has items (e.g. a CDN served a stale empty shell, or the items came
  // back), hide the banner and clear the flag so we don't show a false notice.
  var endpoint =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js';

  fetch(endpoint)
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      if (cart && cart.item_count > 0) {
        hide();
        clearIntent();
      }
    })
    .catch(function () {});
})();
